import { useCallback, useEffect, useRef, useState } from 'react'
import { useSwiper } from 'swiper/react'
import { useGridBlock, usePage } from '../../../contexts'
import { sendGA4 } from '../../../utils'
import { Arrow } from './icons'
import { SwiperButton, SwiperButtonContainer } from './NavButton.style'
import { reelsHe } from '../../../locales/reels.he'

export const NavButton = () => {
  const swiper = useSwiper()
  const [canNavBack, setCanNavBack] = useState<boolean>(false)
  const [canNavForward, setCanNavForward] = useState<boolean>(true)
  const pageData = usePage()
  const clicksCount = useRef(0)
  const { gridId: grid_id } = useGridBlock()

  useEffect(() => {
    const updateNav = () => {
      setCanNavBack(!swiper.isBeginning)
      setCanNavForward(!swiper.isEnd)
    }

    updateNav()

    swiper.on('slideChange', updateNav)
    swiper.on('reachBeginning', updateNav)
    swiper.on('reachEnd', updateNav)
    swiper.on('fromEdge', updateNav)

    return () => {
      swiper.off('slideChange', updateNav)
      swiper.off('reachBeginning', updateNav)
      swiper.off('reachEnd', updateNav)
      swiper.off('fromEdge', updateNav)
    }
  }, [swiper])

  const handleOnSlide = useCallback(
    (direction: 'next' | 'prev') => {
      if (direction === 'next') {
        swiper.slideNext()
      } else {
        swiper.slidePrev()
      }
      clicksCount.current += 1
      sendGA4({
        eventName: 'vertical_comp_arrow_click',
        pageData: pageData,
        direction,
        clicksCount: clicksCount.current,
        grid_id,
      })
    },
    [grid_id, pageData, swiper]
  )

  return (
    <SwiperButtonContainer>
      <SwiperButton
        type='button'
        aria-label={reelsHe.previous}
        theme={{ role: 'prev' }}
        onClick={() => handleOnSlide('prev')}
      >
        {canNavBack && <Arrow />}
      </SwiperButton>
      <SwiperButton
        type='button'
        aria-label={reelsHe.next}
        theme={{ role: 'next' }}
        onClick={() => handleOnSlide('next')}
      >
        {canNavForward && <Arrow />}
      </SwiperButton>
    </SwiperButtonContainer>
  )
}
